(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-stream')) {
    customElements.define('collection-stream', class extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[id^="Slider-"]');
        this.slider = this.querySelector('slider-component');
        if (!this.list) return;
        this.onScroll = () => this.checkNext();
        this.list.addEventListener('scroll', this.onScroll, { passive: true });
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.loadNext();
        }, { root: this.list, rootMargin: '0px 600px' });
        this.observeNext();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.list?.removeEventListener('scroll', this.onScroll);
        this.request?.abort();
      }

      observeNext() {
        this.next = this.list.querySelector('[data-next-url]');
        this.observer.disconnect();
        if (this.next) this.observer.observe(this.next);
      }

      checkNext() {
        if (!this.next || this.loading) return;
        const listRect = this.list.getBoundingClientRect();
        if (this.next.getBoundingClientRect().left < listRect.right + 600) this.loadNext();
      }

      async loadNext() {
        if (!this.next || this.loading) return;
        this.loading = true;
        this.request = new AbortController();
        try {
          const url = new URL(this.next.dataset.nextUrl, window.location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, { signal: this.request.signal });
          if (!response.ok) throw new Error('Collection request failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = html.getElementById(this.list.id);
          if (!incoming || !this.isConnected) throw new Error('Collection section unavailable');
          const items = [...incoming.children];
          if (!items.some(item => item.id.startsWith('Slide-'))) throw new Error('Collection page empty');
          items.forEach(item => item.classList.remove('scroll-trigger', 'animate--slide-in'));
          this.next.remove();
          this.list.append(...items);
          this.slider.resetPages();
          this.observeNext();
        } catch (error) {
          if (error.name !== 'AbortError') this.observer.disconnect();
        } finally {
          this.loading = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('dc-footer-accordion')) {
    customElements.define('dc-footer-accordion', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.desktop = window.matchMedia('(min-width: 750px)');
        this.updateLayout = () => {
          this.details.open = this.desktop.matches;
          this.summary.tabIndex = this.desktop.matches ? -1 : 0;
          if (this.desktop.matches) this.summary.setAttribute('aria-disabled', 'true');
          else this.summary.removeAttribute('aria-disabled');
        };
        this.preventDesktopToggle = (event) => {
          if (this.desktop.matches && event.target.closest('summary')) event.preventDefault();
        };
        this.desktop.addEventListener('change', this.updateLayout);
        this.addEventListener('click', this.preventDesktopToggle);
        this.updateLayout();
      }
      disconnectedCallback() {
        this.desktop.removeEventListener('change', this.updateLayout);
        this.removeEventListener('click', this.preventDesktopToggle);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  function initializeDogsCollectiveMenus() {
    document.querySelectorAll('.header__inline-menu').forEach((menu) => {
      if (menu.dataset.dcHoverInitialized) return;
      menu.dataset.dcHoverInitialized = 'true';
      const items = menu.querySelectorAll('header-menu > details');
      items.forEach((item) => {
        item.addEventListener('mouseenter', () => {
          if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          items.forEach((other) => {
            if (other !== item && !other.contains(document.activeElement)) other.removeAttribute('open');
          });
          item.setAttribute('open', '');
        });
        item.addEventListener('mouseleave', () => {
          if (!item.contains(document.activeElement)) item.removeAttribute('open');
        });
      });
    });
  }
  initializeDogsCollectiveMenus();
  document.addEventListener('shopify:section:load', initializeDogsCollectiveMenus);

  } catch(e) { console.error(e); }
})();
})();
